import moment from 'moment';

import {DateFormat, TimeFormat, TimeFormatSpecificity} from 'enums';

const getRange = (
    startDate: moment.MomentInput,
    endDate: moment.MomentInput,
    unit: moment.unitOfTime.Diff,
    format: string,
    {includeEndDate = false, increment = 1} = {}
) => {
    const fromDate = moment(startDate);
    const toDate = moment(endDate);
    const diff = Math.max(toDate.diff(fromDate, unit), 1);
    const range = [];
    for (let i = 0; includeEndDate ? i <= diff : i < diff; i += increment) {
        range.push(moment(startDate).add(i, unit).format(format));
    }
    return range;
};

const getNextMinutesDate = (timeZone: string, divisor = 1) => {
    const date = moment.tz(timeZone).set({s: 0, ms: 0});
    const minutes = Math.ceil(date.minutes() / divisor) * divisor;
    return date.set({m: minutes});
};

const guessTimeZone = () => moment.tz.guess();

const specifyTimeFormat = (timeFormat: TimeFormat, specificity?: TimeFormatSpecificity) => {
    if (!specificity) {
        return timeFormat;
    }
    const splitted = timeFormat?.split(' ');
    if (!splitted) {
        return timeFormat;
    }
    if (specificity === TimeFormatSpecificity.Seconds) {
        splitted[0] += ':ss';
    }
    if (specificity === TimeFormatSpecificity.Milliseconds) {
        splitted[0] += ':ss.SSS';
    }
    return splitted.join(' ');
};

const getDateTimeFormat = (dateFormat: DateFormat, timeFormat: TimeFormat, specificity?: TimeFormatSpecificity) => {
    const time = specifyTimeFormat(timeFormat, specificity);
    return `${dateFormat} ${time}`;
};

export const dateUtils = {
    getRange,
    getNextMinutesDate,
    guessTimeZone,
    specifyTimeFormat,
    getDateTimeFormat
};